import Vue from 'vue'
import Attachment from './Attachment'
import PrettyDateTime from './PrettyDateTime.vue'
import AttachmentLink from './AttachmentLink.vue'
import UserGroupSelect from './UserGroupSelect.vue'
import DatePicker from './DatePicker.vue'
import TimePicker from './TimePicker.vue'
import BooleanValue from './BooleanValue.vue'
import UserSelect from './UserSelect.vue'
import MoneyInput from './MoneyInput.vue'
import EsQueryGroup from "./EsQueryGroup";

Vue.component('Attachment', Attachment)
Vue.component('PrettyDateTime', PrettyDateTime)
Vue.component('AttachmentLink', AttachmentLink)
Vue.component('UserGroupSelect', UserGroupSelect)
Vue.component('DatePicker', DatePicker)
Vue.component('TimePicker', TimePicker)
Vue.component('BooleanValue', BooleanValue)
Vue.component('UserSelect', UserSelect)
Vue.component('MoneyInput', MoneyInput)
Vue.component('EsQueryGroup', EsQueryGroup)
